import React from "react";
import { Card, Row, Col, Typography, Breadcrumb, theme } from "antd";
import {
  UserOutlined,
  QrcodeOutlined,
  ShopOutlined,
  ScheduleOutlined,
  MessageOutlined,
  NotificationOutlined,
} from "@ant-design/icons";
import { useAuth } from "../../context/AuthProvider";
import ForbiddenPage from "../Status/ForbiddenPage";
import { useNavigate } from "react-router-dom";

const { Title, Paragraph } = Typography;

export default function SuperAdminDashboard() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { token } = theme.useToken();

  if (user?.email !== "superadmin@scanjoy.com") {
    return <ForbiddenPage />;
  }

  const actions = [
    {
      key: "manageAdmins",
      label: "Gestionar Administradores",
      icon: <UserOutlined />,
      path: "/superadmin/manage-admins",
    },
    {
      key: "siteSettings",
      label: "Configuración del Sitio",
      icon: <QrcodeOutlined />,
      path: "/superadmin/site-settings",
    },
    {
      key: "auditLogs",
      label: "Registros de Auditoría",
      icon: <ShopOutlined />,
      path: "/superadmin/audit-logs",
    },
    {
      key: "systemHealth",
      label: "Estado del Sistema",
      icon: <ScheduleOutlined />,
      path: "/superadmin/system-health",
    },
    {
      key: "userFeedback",
      label: "Comentarios de Usuarios",
      icon: <MessageOutlined />,
      path: "/superadmin/user-feedback",
    },
    {
      key: "globalNotifications",
      label: "Notificaciones Globales",
      icon: <NotificationOutlined />,
      path: "/superadmin/global-notifications",
    },
  ];

  return (
    <div
      style={{
        padding: "clamp(16px, 4vw, 32px)",
        maxWidth: 1200,
        margin: "0 auto",
      }}
    >
      <Breadcrumb
        style={{ marginBottom: 24, color: token.colorTextSecondary }}
        items={[
          { title: "Inicio" },
          { title: "Panel de Super Administrador" },
        ]}
      />

      <Card
        style={{
          borderRadius: 16,
          boxShadow: token.boxShadowSecondary,
          backgroundColor: token.colorBgContainer,
        }}
        styles={{
          body: {
            padding: "clamp(24px, 5vw, 32px)",
          },
        }}
      >
        <Title level={2} style={{ marginBottom: 8 }}>
          Panel de Super Administrador
        </Title>

        <Paragraph style={{ marginBottom: 24, color: token.colorTextSecondary }}>
          Bienvenido al panel de super administrador. Aquí puedes gestionar todas
          las configuraciones avanzadas del sistema.
        </Paragraph>

        <Row gutter={[24, 24]}>
          {actions.map(({ key, label, icon, path }) => (
            <Col xs={24} sm={12} md={8} key={key}>
              <Card
                hoverable
                onClick={() => navigate(path)}
                style={{
                  borderRadius: 12,
                  boxShadow: token.boxShadowTertiary,
                  textAlign: "center",
                  padding: "24px 16px",
                  backgroundColor: token.colorBgContainer,
                }}
              >
                <div style={{ fontSize: 32, marginBottom: 12 }}>
                  {icon}
                </div>
                <Title level={5} style={{ margin: 0 }}>
                  {label}
                </Title>
              </Card>
            </Col>
          ))}
        </Row>
      </Card>
    </div>
  );
}
